export const DECIMAL_6 = 6 as const;
